import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';
import { translate } from 'react-i18next';
import Table from 'antd/lib/table';
import { t } from '../../../app/i18n';
import { ResponsiveTable } from '../../../common/components/data-display';
import { formatDateTime } from '../../../common/utils/helpers';

const MessageStatus = {
  GENERATED: 1,
  SENT: 2
}

const Column = Table.Column;


const statusFunction = (status) => {
  return {
    children: <span>{status == MessageStatus.GENERATED ? `${t("Vygenerovaná")}` : `${t("Zaslaná")}`}</span>,
  };
};

const sentDateFunction = (sentDate) => {
  return {
    children: <span>{sentDate ? `${formatDateTime(sentDate)}` : ``}</span>,
  };
};
const nameFunction = (receiverName) => {
  return {
    children: <span>{`${receiverName}`}</span>,
  };
};
const receiverFunction = (receiver) => {
  return {
    children: <span>{`${receiver}`}</span>,
  };
};
const messageFunction = (message) => {
  return {
    children: <span>{`${message}`}</span>,
  };
};




const SmsLogsTable = ({ smsLogs, loading, onChange, pagination, t }) => {

  smsLogs.forEach(item => {
    item.receiverName = item.receiverNameFirst + ' ' + item.receiverNameLast
  })
  return (

    <ResponsiveTable
      dataSource={smsLogs}
      loading={loading}
      onChange={onChange}
      pagination={pagination}
      rowKey={smsLog => smsLog.id}
      rowClassName={smsLog => smsLog.nonpayer ? 'nonpayer-row' : ''}
    >
      <Column
        title={t('Dátum zaslania')}
        dataIndex="sentDate"
        key="sentDate"
        render={(item) => sentDateFunction(item)}
      />
      <Column
        title={t('Stav')}
        dataIndex="status"
        key="status"
        render={(item) => statusFunction(item)}
      />

      <Column
        title={t('Prijímateľ')}
        dataIndex="receiverName"
        key="receiverName"
        render={(item) => nameFunction(item)}
      />
      <Column
        title={t('Telefónne číslo')}
        dataIndex="receiver"
        key="receiver"
        render={(item) => receiverFunction(item)}
      />
      <Column
        title={t('Text SMS správy')}
        dataIndex="message"
        key="message"
        render={(item) => messageFunction(item)}
      />
    </ResponsiveTable>
  )
};

SmsLogsTable.propTypes = {
  smsLogs: PropTypes.array.isRequired,
  actions: PropTypes.func,
  loading: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
  pagination: PropTypes.object.isRequired,
  t: PropTypes.func.isRequired,
};

export default translate()(SmsLogsTable);



// WEBPACK FOOTER //
// ./src/features/messaging-dashboard/components/SmsLogsTable.js